export function numberFormat(
    value,
    mindigits = 0,
    maxdigits = 2,
    style = 'decimal' // decimal, currency, percent, unit
) {
    value = style === 'percent' ? value / 100 : value
    return new Intl.NumberFormat('en-IN', {
        style: style,
        currency: 'INR',
        minimumFractionDigits: mindigits,
        maximumFractionDigits: maxdigits,
        // roundingMode: 'floor',
    }).format(value)
}

export function userName(user) {
    return (
        <div className="flex items-center gap-3">
            <div className="relative w-full h-11 max-w-11">
                <img src={user.image_url + '?h=44&w=44&aspect=true&type=webp'} alt={user.name} />
            </div>
            <div className="w-full truncate">
                <p className="text-black dark:text-white">{user.name}</p>
                <p className="text-xs font-medium">{user.email}</p>
            </div>
        </div>
    )
}

export function storeName(store, image = true) {
    if (!store) return null
    return (
        <div className="flex items-center gap-3">
            {image && (
                <div className="relative w-full h-11 max-w-11">
                    <img src={store.logo_url + '?h=44&w=44&aspect=true&type=webp'} alt={store.business_name ?? store.name} />
                </div>
            )}
            <div className="w-full truncate">
                <p className="text-black dark:text-white">{store.business_name ?? store.name}</p>
                <p className="text-xs font-medium">{store.number}</p>
            </div>
        </div>
    )
}

export function userVerified(verified, check = false) {
    var className = ''
    var name = ''
    switch (verified) {
        case null:
            className = 'text-danger bg-danger'
            name = 'Not Verified'
            break
        default:
            className = 'text-success bg-success'
            name = 'Verified'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export const userVerifiedStatus = [
    {
        id: 0,
        label: 'Not Verified',
    },
    {
        id: 1,
        label: 'Verified',
    },
]

export function userStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Active'
            break
        case 2:
            className = 'text-info bg-info'
            name = 'Pending'
            break
        case 0:
            className = 'text-danger bg-danger'
            name = 'Inactive'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Inactive',
                },
                {
                    id: 1,
                    label: 'Active',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function BagTypes(types = '', check = false) {
    var className = ''
    var name = ''
    switch (types) {
        case 0:
            className = 'text-warning bg-warning'
            name = 'Bin Boxes'
            break
        case 1:
            className = 'text-info bg-info'
            name = 'Bin Bags'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Collection Bags'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Bin Boxes',
                },
                {
                    id: 1,
                    label: 'Bin Bags',
                },
                {
                    id: 2,
                    label: 'Collection Bags',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}
export function collectionPoints(status, name = '', check = false) {
    var className = ''
    switch (status) {
        case 0:
            className = 'text-info bg-info'
            break
        case 1:
            className = 'text-success bg-success'
            break
        case 2:
            className = 'text-danger bg-danger'
            break
        case 3:
            className = 'text-warning bg-warning'
            break
        default:
            className = 'text-danger bg-danger'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function collectionPointsType(type = '', collection_point_other = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-warning bg-warning'
            name = 'Commerical contractor'
            break
        case 1:
            className = 'text-info bg-info'
            name = 'Retail store'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Accessory suppliers'
            break
        case 3:
            className = 'text-success bg-success'
            name = 'Full Member'
            break
        case 4:
            className = 'text-danger bg-danger'
            name = 'Other - ' + collection_point_other
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Commerical contractor',
                },
                {
                    id: 1,
                    label: 'Retail store',
                },
                {
                    id: 2,
                    label: 'Accessory suppliers',
                },
                {
                    id: 3,
                    label: 'Full Member',
                },
                {
                    id: 4,
                    label: 'Other',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function AffiliateType(types = '', check = false) {
    var className = ''
    var name = ''
    switch (types) {
        case 0:
            className = 'text-warning bg-warning'
            name = 'Reprocessor'
            break
        case 1:
            className = 'text-info bg-info'
            name = 'Manufacturer'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Other'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Reprocessor',
                },
                {
                    id: 1,
                    label: 'Manufacturer',
                },
                {
                    id: 2,
                    label: 'Other',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function binBagsStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Active'
            break
        case 2:
            className = 'text-info bg-info'
            name = 'In Shipments'
            break
        default:
            className = 'text-danger bg-danger'
            name = 'Inactive'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function projectBagDropStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Confirm'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function pickupStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 0:
            className = 'text-info bg-info'
            name = 'Pending'
            break
        case 1:
            className = 'text-warning bg-warning'
            name = 'Requested'
            break
        case 2:
            className = 'text-success bg-success'
            name = 'Accepted'
            break
        case 3:
            className = 'text-danger bg-danger'
            name = 'Rejected'
            break
        case 4:
            className = 'text-info bg-info'
            name = 'Partially Dispatched'
            break
        case 5:
            className = 'text-success bg-success'
            name = 'Dispatched'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Pending',
                },
                {
                    id: 1,
                    label: 'Requested',
                },
                {
                    id: 2,
                    label: 'Accepted',
                },
                {
                    id: 3,
                    label: 'Rejected',
                },
                {
                    id: 4,
                    label: 'Partially Dispatched',
                },
                {
                    id: 5,
                    label: 'Dispatched',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function pickupPaletStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-warning bg-warning'
            name = 'In Storage'
            break
        case 2:
            className = 'text-success bg-success'
            name = 'Dispatched'
            break
        default:
            className = 'text-info bg-info'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function dispatchStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-success'
            name = 'Done'
            break
        default:
            className = 'text-info bg-info'
            name = 'In Transit'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function userStore(store = '', check = false) {
    var className = ''
    var name = ''
    switch (store) {
        case 0:
            className = 'text-warning bg-warning'
            name = 'Collection Point'
            break
        case 1:
            className = 'text-info bg-info'
            name = 'Recycler'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Collection Point',
                },
                {
                    id: 1,
                    label: 'Recycler',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function projectType(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-warning bg-warning'
            name = 'Residential'
            break
        case 1:
            className = 'text-info bg-info'
            name = 'Commercial'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Residential',
                },
                {
                    id: 1,
                    label: 'Commercial',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function bagRequestStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-success bg-info'
            name = 'Accepted'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Rejected'
            break
        case 3:
            className = 'text-success bg-success'
            name = 'Sent'
            break
        default:
            className = 'text-warning bg-warning'
            name = 'Pending'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function yesNo(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'No'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Yes'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'No',
                },
                {
                    id: 1,
                    label: 'Yes',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function collectionPointCollectorType(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'Private'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Trade'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Private',
                },
                {
                    id: 1,
                    label: 'Trade',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function collectionPointStatus(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-info bg-info'
            name = 'Pending'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Accepted'
            break
        case 2:
            className = 'text-danger bg-danger'
            name = 'Rejected'
            break
        case 3:
            className = 'text-warning bg-warning'
            name = 'Disassociate'
            break
        case 4:
            className = 'text-danger bg-danger'
            name = 'Disassociated'
            break
        case 5:
            name = [
                {
                    id: 0,
                    label: 'Pending',
                },
                {
                    id: 1,
                    label: 'Accepted',
                },
                {
                    id: 2,
                    label: 'Rejected',
                },
            ]
            break
        default:
            name = [
                {
                    id: 3,
                    label: 'Disassociate',
                },
                {
                    id: 4,
                    label: 'Accepted',
                },
                {
                    id: 1,
                    label: 'Rejected',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function contactStatus(status, check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 1:
            className = 'text-warning bg-warning'
            name = 'Work In Progress'
            break
        case 2:
            className = 'text-success bg-success'
            name = 'Resolve'
            break
        case 3:
            className = 'text-danger bg-danger'
            name = 'Not Resolve'
            break
        case 4:
            className = 'text-warning bg-warning'
            name = 'On Hold'
            break
        default:
            className = 'text-info bg-info'
            name = 'Submit'
            break
    }
    if (check) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function memberType(status = '', check = false) {
    var className = ''
    var name = ''
    switch (status) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'Existing'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'Future'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Existing',
                },
                {
                    id: 1,
                    label: 'Future',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}

export function pickupType(type = '', check = false) {
    var className = ''
    var name = ''
    switch (type) {
        case 0:
            className = 'text-danger bg-danger'
            name = 'Dispatch'
            break
        case 1:
            className = 'text-success bg-success'
            name = 'In Storage'
            break
        default:
            name = [
                {
                    id: 0,
                    label: 'Dispatch',
                },
                {
                    id: 1,
                    label: 'In Storage',
                },
            ]
            break
    }
    if (check || !className) return name
    return <div className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${className}`}>{name}</div>
}
